export type ComunicadoCanal = "EMAIL" | "PUSH" | "AMBOS";

export type ComunicadoPublico =
  | "TODOS_USUARIOS"
  | "INSCRITOS_EVENTO"
  | "INSCRITOS_CIDADE"
  | "INSCRITOS_EQUIPE"
  | "USUARIO_ESPECIFICO";

export type ComunicadoCampanhaStatus =
  | "RASCUNHO"
  | "ENFILEIRADO"
  | "PROCESSANDO"
  | "CONCLUIDO"
  | "ERRO"
  | "CANCELADO";

export type ComunicadoEnvioCanal = "EMAIL" | "PUSH";
export type ComunicadoEnvioStatus = "ENVIADO" | "FALHA" | "IGNORADO";

export interface IVariavelComunicado {
  chave: string;
  descricao: string;
  exemplo: string;
  grupos: string[];
}

export interface IContagemPublico {
  totalRegistros: number;
  comEmail: number;
  comPush: number;
}

export interface IFiltrosPublicoEvento {
  cidades: string[];
  equipes: string[];
}

export interface IComunicadoPreview {
  assuntoEmail: string | null;
  tituloPush: string | null;
  corpo: string;
  contexto: Record<string, string>;
}

export interface IComunicadoCampanha {
  id: string;
  tituloInterno: string;
  canal: ComunicadoCanal;
  publico: ComunicadoPublico;
  eventoId: number | null;
  userId: string | null;
  filtroCidade: string | null;
  filtroEquipe: string | null;
  assuntoEmail: string | null;
  tituloPush: string | null;
  corpoTemplate: string;
  urlImagePush: string | null;
  status: ComunicadoCampanhaStatus;
  totalDestinatarios: number;
  totalEnviados: number;
  totalFalhas: number;
  totalIgnorados: number;
  erroResumo: string | null;
  criadoPorId: string;
  iniciadoEm: string | null;
  concluidoEm: string | null;
  createAt: string;
  updatedAt: string;
  criadoPor?: { id: string; nome: string; email: string };
  evento?: { id: number; titulo: string; slug: string } | null;
}

export interface IComunicadoEnvio {
  id: string;
  campanhaId: string;
  canal: ComunicadoEnvioCanal;
  userId: string | null;
  atletaId: number | null;
  inscricaoId: number | null;
  destino: string;
  status: ComunicadoEnvioStatus;
  erro: string | null;
  assuntoRenderizado: string | null;
  corpoRenderizado: string | null;
  enviadoEm: string;
}

export interface IComunicadoListResponse {
  items: IComunicadoCampanha[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface IComunicadoEnviosResponse {
  items: IComunicadoEnvio[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export type ComunicadoCreatePayload = {
  tituloInterno: string;
  canal: ComunicadoCanal;
  publico: ComunicadoPublico;
  eventoId?: number | null;
  userId?: string | null;
  filtroCidade?: string[] | null;
  filtroEquipe?: string[] | null;
  assuntoEmail?: string | null;
  tituloPush?: string | null;
  corpoTemplate: string;
  urlImagePush?: string | null;
};

export type ComunicadoPreviewPayload = {
  corpoTemplate: string;
  assuntoEmail?: string | null;
  tituloPush?: string | null;
  eventoId?: number;
  atletaId?: number;
  userId?: string;
};

export const CANAL_LABEL: Record<ComunicadoCanal, string> = {
  EMAIL: "E-mail",
  PUSH: "Push",
  AMBOS: "E-mail + Push",
};

export const PUBLICO_LABEL: Record<ComunicadoPublico, string> = {
  TODOS_USUARIOS: "Todos os usuários",
  INSCRITOS_EVENTO: "Inscritos do evento",
  INSCRITOS_CIDADE: "Inscritos por cidade",
  INSCRITOS_EQUIPE: "Inscritos por equipe",
  USUARIO_ESPECIFICO: "Usuário específico",
};

export const STATUS_LABEL: Record<ComunicadoCampanhaStatus, string> = {
  RASCUNHO: "Rascunho",
  ENFILEIRADO: "Enfileirado",
  PROCESSANDO: "Processando",
  CONCLUIDO: "Concluído",
  ERRO: "Erro",
  CANCELADO: "Cancelado",
};

export const ENVIO_STATUS_LABEL: Record<ComunicadoEnvioStatus, string> = {
  ENVIADO: "Enviado",
  FALHA: "Falha",
  IGNORADO: "Ignorado",
};
